<script setup lang="ts">
import { useMerchantSlug } from './composables/useMerchantSlug';
import type { NuxtError } from '#app';

defineProps<{
	error: NuxtError;
}>();

const route = useRoute();
const merchantSlug = useMerchantSlug(route);
</script>

<template>
	<div class="h-full">
		<NuxtLayout name="blank">
			<div class="flex min-h-full flex-1 flex-col justify-center">
				<ErrorMaintenanceMode v-if="error.statusText === 'app-is-under-maintenance'" />
				<ErrorNoAdmin v-else-if="error.status === 403" />
				<ErrorScreen
					v-else-if="error.status === 404"
					variant="not-found"
					:title="$t('page.error.pageNotFound.title')"
				>
					<UButton
						:to="merchantSlug
							? { name: 'MerchantDashboard', params: { merchantSlug } }
							: '/'"
					>
						{{ $t('page.error.button.backToHome') }}
					</UButton>
				</ErrorScreen>
				<UCard
					v-else
					class="text-center max-w-xl mx-auto w-full"
				>
					<UIcon
						name="i-lucide-circle-x"
						class="text-6xl text-red-500"
					/>
					<h1 class="text-3xl">
						{{ error.status }}
					</h1>
					<p class="text-lg">
						{{ error?.message }}
					</p>
					<p class="font-mono text-left overflow-x-scroll bg-muted p-4 text-sm mt-4">
						{{ error.stack }}
					</p>
					<template #footer>
						<NuxtLink to="/">
							<UButton>
								{{ $t('page.error.button.backToHome') }}
							</UButton>
						</NuxtLink>
					</template>
				</UCard>
			</div>
			<svg
				class="fixed bottom-0 left-0 z-[-1] hidden lg:block"
				width="404"
				height="404"
				fill="none"
				viewBox="0 0 404 404"
			>
				<defs>
					<pattern
						id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
						x="0"
						y="0"
						width="20"
						height="20"
						patternUnits="userSpaceOnUse"
					>
						<rect
							x="0"
							y="0"
							width="4"
							height="4"
							class="text-neutral-200 dark:text-neutral-800"
							fill="currentColor"
						/>
					</pattern>
				</defs>
				<rect
					width="404"
					height="784"
					fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)"
				/>
			</svg>
		</NuxtLayout>
	</div>
</template>
